import * as yup from "yup";
import { validate, createValidationSchema } from "@";

export const loginSchema = createValidationSchema({
  email: validate("email", "email"),
  password: validate("req", "password"),
});

export const forgotPasswordSchema = createValidationSchema({
  phoneNumber: validate("phone", "phoneNumber"),
});

export const resetPassSchema = createValidationSchema({
  newPassword: validate("password", "newPassword"),
});

export const profileSchema = createValidationSchema({
  displayName: validate("req", "displayName"),
  password: yup
    .string()
    .nullable()
    .trim()
    .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*_=+-]).{8,20}$/, {
      message: "8 احرف مع (أحرف صغيرة ، أحرف كبيرة ، ارقام و رموز)",
      excludeEmptyString: true,
    })

    .label("password"),
  email: validate("email", "email"),
  phoneNumber: validate("phone", "phoneNumber"),
});
